module.exports = __webpack_public_path__ + "img/2.daf86b92.jpg";